import React from "react";
import loading from "../images/loading.svg";

const ImageLoading = () => {
  return (
    <img
      src={loading}
      alt="loading"
      className="w-[24px] h-[24px] animate-spin"
    />
  );
};

export default ImageLoading;
